import React from "react";
import yellowOriOrb from "Assets/images/Ori.png";
import styles from "./OriAvatar.module.scss";

// Ori.png has transparent padding baked in around the orb. Overscale the
// image inside a tightly-clipped box so the visible orb matches `size` in
// layout, instead of letterboxing to ~30% of it. Higher cropScale crops tighter.
const DEFAULT_CROP_SCALE = 1.6;

// Crop for surfaces that present Ori as a solid orb filling its box (chat
// header, empty state). The nav icon sits a touch looser — see SNavbar.
export const ORI_ORB_CROP_SCALE = 2.5;

interface OriAvatarProps {
  size?: number;
  cropScale?: number;
  testId?: string;
}

const OriAvatar: React.FC<OriAvatarProps> = ({
  size = 32,
  cropScale = DEFAULT_CROP_SCALE,
  testId = "ori-avatar",
}) => (
  <div
    className={styles.container}
    style={{ width: size, height: size }}
    data-testid={testId}
    aria-label="Ori"
  >
    <img
      src={yellowOriOrb}
      alt=""
      width={size * cropScale}
      height={size * cropScale}
      className={styles.avatar}
    />
  </div>
);

export default OriAvatar;
